export enum HOLIDAY_STATUS {
    Pending = 0,
    Approved = 1,
    Declined = 2,
}
